import { extractAttributesValues } from 'pages/quotes/helpers';


const getDefaultProductAttributes = () => ({
  savings: 0,
  subscription_label: '',
  subscription_active: '0',
  additional_subscription_price: 0,
  quotepro_discounts: '[]',
});

const parseDiscounts = (discountsString) => {
  try {
    return JSON.parse(discountsString);
  } catch (error) {
    return [];
  }
};

const getProductAttributes = (product, isAttributes, customAttributes, attributesList) => {
  return isAttributes
    ? product || extractAttributesValues(customAttributes, attributesList)
    : getDefaultProductAttributes();
};

export const handleSelectDataSource = (
  sku: string,
  isAttributes: boolean,
  product,
  subscriptionOptionsBySku,
  customAttributes,
  attributesList = []
) => {
  const productInQuote = product?.products?.[sku]?.product;

  const subscriptionOptions = productInQuote
    ? productInQuote?.subscription_options
    : subscriptionOptionsBySku?.[sku] || [];

  const productInQuoteDiscount = parseDiscounts(productInQuote?.quotepro_discounts);
  const existingDiscountValues = parseDiscounts(getProductAttributes(productInQuote, isAttributes, customAttributes, attributesList)?.quotepro_discounts);

  const productDiscounts = productInQuote
    ? productInQuoteDiscount
    : existingDiscountValues || [];

  return {
    productInQuote,
    productAttributes: getProductAttributes(productInQuote, isAttributes, customAttributes, attributesList),
    subscriptionOptions: [...subscriptionOptions].sort((a, b) => Number(a.ssort_order) - Number(b.ssort_order)),
    productDiscounts,
  };
};
